import hash from 'utils/hash';
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
  DEFAULT_HIDE_DURATION,
} from 'constants/constants';
import { IAlertType } from './_types';
import { useAppDispatch } from 'store/hooks';
import { alertAdd } from 'store/reducers/appReducer';

const useAlerts = () => {
  const dispatch = useAppDispatch();

  const addAlert = (text: string, type: IAlertType, hideDuration: number = DEFAULT_HIDE_DURATION) =>
    dispatch(
      alertAdd({
        text: text,
        type: type,
        id: hash(),
        hideDuration,
      }),
    );

  const addSuccessAlert = (text: string, hideDuration: number = DEFAULT_HIDE_DURATION) =>
    addAlert(text, ALERT_TYPE_SUCCESS, hideDuration);
  const addErrorAlert = (text: string, hideDuration: number = DEFAULT_HIDE_DURATION) =>
    addAlert(text, ALERT_TYPE_ERROR, hideDuration);
  const addInfoAlert = (text: string, hideDuration: number = DEFAULT_HIDE_DURATION) =>
    addAlert(text, ALERT_TYPE_INFO, hideDuration);

  return {
    addInfoAlert,
    addErrorAlert,
    addSuccessAlert,
  };
};

export default useAlerts;
